import SettingsForm from './SettingsForm';

export * from './DangerZone';
export * from './types';

export default SettingsForm;
